module.exports = __webpack_public_path__ + "media/assets/partners/dappei-2331cbde807114624bce011c0032db7b.svg";